import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-workflow-stepper-skeleton',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './workflow-stepper-skeleton.component.html'
})
export class WorkflowStepperSkeletonComponent {}
